import script from "./FavoriteProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./FavoriteProducts.vue?vue&type=script&setup=true&lang=ts"

import "./FavoriteProducts.vue?vue&type=style&index=0&id=7e671dce&scoped=true&lang=scss"
import "./FavoriteProducts.vue?vue&type=style&index=1&id=7e671dce&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e671dce"]])

export default __exports__